import { PRACTITIONER } from "@/core/constants";
import { CREATE_PRACTITIONER_PROFILE_MUTATION } from "@/graphql/accounts";
import useDjangoGraphqlForm from "@/hooks/form/useDjangoGraphqlForm";

import buildPractitionerApplicationMutationInput from "../buildPractitionerApplicationMutationInput";
import Common from "./CommonForm";

export default function LoggedOutForm({ setFormSubmitted }) {
  const api = useDjangoGraphqlForm({
    transformer: buildPractitionerApplicationMutationInput,
    mutation: CREATE_PRACTITIONER_PROFILE_MUTATION,
    mutationName: "createPractitionerProfileMutation",
    defaultValues: {
      tier: PRACTITIONER,
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      dateOfBirth: "",
      gender: "",

      practitionerType: "",
      professionalBodies: [],
      documents: [],

      phoneNumber: "",
      jobRole: "",
      specialisms: [],
      businessName: "",
      businessLocationCity: "",
      businessCountry: "",
      clientsPerMonth: "",
      orderTestingTimeline: "",
      expectedTestsPerMonth: "",
      supplementRecommendationMethod: "",
      supplementProvider: "",
      insuranceProvider: "",
      insurancePolicyNumber: "",
      insuranceExpiryDate: "",
      insuranceEvidence: null,

      acceptTerms: false
    },
    handleSuccess: () => {
      setFormSubmitted(true);
    }
  });

  return <Common api={api} showLoginLink showPasswordFields />;
}
